
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-03 16:12:54
-->
<template>
  <div>
    <el-drawer
      :title="'发起约稿'"
      :visible.sync="visibleTwo"
      @close="closeDra"
      :size="width<=720?'90%':'500px'"
      :with-header="true"
      class="box"
      :wrapperClosable="false"
    >
   
        <div class="title-box">
        <i class="el-icon-info icon-title"></i>
        <div>
          原文采纳是将稿件按原文内容直接推送至目标栏目下，在后台查看时稿件标题前将带有“推送”标签以便于区分；
          原文采纳的稿件，其创作人员所属组织有权力对稿件进行内容编辑，编辑后，目标栏目中的稿件将即时同步。
        </div>
      </div>
       <a-spin :spinning="loadingShow">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-width="width<=720?'130px':'110px'"
        class="demo-ruleForm"
      >
        <el-form-item label="约稿标题" prop="title">
          <el-input
            v-model="ruleForm.title"
            maxlength="100"
            placeholder="请输入约稿标题"
          ></el-input>
        </el-form-item>
          <el-form-item label="约稿单位"  prop="unit">
          <el-input
           maxlength="50"
            v-model="ruleForm.unit"
            placeholder="请输入约稿单位"
          ></el-input>
        </el-form-item>
       <el-form-item label="承办单位" prop="undertakeUnit">
           <div @click="appointmentUnit" :style="{paddingBottom:listData.length > 0?'8px':'0px'}" class="unit-box">
              <div v-if="listData.length > 0" class="unit-item" v-for="(item,index) in listData"><div class="item-text"><span :title="item.name">{{item.orgName}}</span></div> <i @click.stop="deleteUnit(index)" class="el-icon-error"></i></div>
              <div style="margin-left:16px" v-if="listData.length == 0">请选择承办单位</div>
           </div>
        </el-form-item>
         <el-form-item label="约稿时间" prop="reservationTime">
            <el-date-picker
              style="width:100%"
              v-model="ruleForm.reservationTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="年/月/日">
            </el-date-picker>
        </el-form-item>
        <el-form-item  label="反馈时间" prop="feedbackTime">
            <div class="fan-kui-box">
                <el-date-picker
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-model="ruleForm.feedbackTime"
                  type="date"
                  placeholder="年/月/日">
                </el-date-picker>
                <div class="zi-qian">之前</div>
            </div>
        </el-form-item>
          <el-form-item label="报送途径" prop="road">
          <el-input
           maxlength="50"
            v-model="ruleForm.road"
            placeholder="请输入报送途径"
          ></el-input>
        </el-form-item>
         <el-form-item label="联系人" prop="contacts">
          <el-input
           maxlength="50"
            v-model="ruleForm.contacts"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
         <el-form-item label="联系电话" prop="phone">
          <el-input
            maxlength="50"
            v-model="ruleForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="约稿信息" prop="information">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="500"
            v-model="ruleForm.information"
            placeholder="请输入约稿信息"
          ></el-input>
        </el-form-item>
      </el-form>
        </a-spin>
       <div v-if="btnShow" class="bottom">
           <div class="form-bottom">
            <el-button
              style="padding: 10px 24px"
              size="small"
              @click="closeDra"
              >关闭</el-button
            >
             <el-button
              style="padding: 10px 24px;background-color: rgba(223, 237, 255, 1);color: rgba(23, 109, 230, 1);border: 1px solid rgba(23, 109, 230, 1);"
              size="small"
              type="primary"
              v-if="codeData.indexOf('407') != -1"
               :loading="loadingThree"
              @click="submit(1)"
              >保存</el-button
            >
            <el-button
              style="padding: 10px 24px"
              size="small"
              type="primary"
              v-if="codeData.indexOf('408') != -1"
              @click="submit(2)"
               :loading="loading"
              >保存并发送</el-button
            >
          </div>
       </div>
   
    
    </el-drawer>
    <organizer @cancellation="cancellation" :dataSource="listData" v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></organizer>
  </div>
</template>

<script>
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
import organizer from './organizer.vue';
import {create,selectViewData,update,details} from './index';
export default {
  data() {
    return {
      ruleForm: {},
      loading:false,
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        unit: [{ required: true, message: "请输入约稿单位", trigger: "blur" }],
        undertakeUnit: [{ required: true, message: "请选择承办单位", trigger: "blur" }],
        reservationTime: [{ required: true, message: "请选择约稿时间", trigger: "blur" }],
        feedbackTime: [{ required: true, message: "请选择反馈时间", trigger: "blur" }],
        road: [{ required: true, message: "请输入报送途径", trigger: "blur" }],
        contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        information: [{ required: true, message: "请输入约稿信息", trigger: "blur" }],
        undertakeUnit: [{ required: true, message: "请选择承办单位", trigger: "blur" }],
      },
      templateIsShow: false,
      templateList: {},
      visibleTwo:false,
      width:'',
      btnShow:true,
      dialogVisible:false,
      listData:[],
      loadingShow:false,
      loadingThree:false,
      codeData:[],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item:{
       type: Object,
      default: ()=>{
        return {}
      },
    }
  },
  components:{
    organizer
  },
  watch:{
    visible(){
      this.visibleTwo = this.visible;
      this.width  = document.documentElement.clientWidth;
      this.getKeyboardState()
       this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
       window.onresize = () => {
          return (() => {
             this.width  = document.documentElement.clientWidth;
          })();
        };
      if(this.visibleTwo){
          if(this.item.id){
              this.deil(this.item.id);
          }else{
            this.ruleForm = {}
            this.listData = [];
          }
          this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
      this.$refs.ruleForm.clearValidate();
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    closeDra(){
      this.$emit("closeDra");
      this.$refs.ruleForm.clearValidate();
    },
    submit(type){
       let array = [];
       for (let index = 0; index < this.listData.length; index++) {
        const element = this.listData[index];
        array.push(element.id)
       }
       this.ruleForm.undertakeUnit = array.join(',')
       this.$refs.ruleForm.validate(valid => {
            if (valid) {
               if(type == 1){
                  this.loadingThree = true;
               }else{
                 this.loading = true;
               }
                if(this.ruleForm.id){
                     update({
                    ...this.ruleForm,
                     state:type,
                  }).then((res)=>{
                      if(res.code == 0){
                          this.$emit("close");
                      }
                       this.loading = false;
                        this.loadingThree = false;
                  })
                }else{
                   create({
                    ...this.ruleForm,
                     state:type,
                  }).then((res)=>{
                      if(res.code == 0){
                          this.$emit("close");
                      }
                      this.loading = false;
                       this.loadingThree = false;
                  })
                }
            }
       })
    },
    deil(id){
        this.loadingShow = true;
        details({
          id,
        }).then((res)=>{
            if(res.code == 0){
                let reqData = JSON.parse(JSON.stringify(res.data))
                delete reqData.undertakeUnitName;
                delete reqData.unitResponses;
                this.ruleForm = reqData;
                this.listData = res.data.unitResponses || [];
            }
            this.loadingShow = false;
        })
    },
    cancellation(){
      this.dialogVisible = false;
    },
     handleClose(list){
       this.dialogVisible = false;
       this.listData = list;
    },
    appointmentUnit(){
         this.dialogVisible = true;
    },
    deleteUnit(index){
        this.listData.splice(index,1)
    }
  },
  created() {
   
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
  padding-bottom: 60px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 70px;
  border-top: solid 1px #e5e7ec;
  background: #fff;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
  .list-box{
                height: 450px;
                overflow-y: auto;
            }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
  .model-name {
    cursor: pointer;
  }
}
.select-model {
  cursor: pointer;
}
.el-button--primary {
  background: #176de6;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  margin-left: 24px;
  margin-right: 24px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .el-input__prefix{
    left: auto;
    right: 5px;
  }
  /deep/.el-input--prefix .el-input__inner{
    padding-left: 15px;
  }
  .zi-qian{
    width: 64px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0px 4px 4px 0px;
    background-color: rgba(245, 247, 250, 1);
    text-align: center;
    border: 1px solid rgba(220, 223, 230, 1);
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: left;
    font-family: Roboto-regular;
  }
  .fan-kui-box{
    display: flex;
    /deep/ .el-input__inner{
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-right: none;
    }
  }
  .unit-box{
    display: flex;
    border-radius: 4px;
    border: 1px solid rgba(220, 223, 230, 1);
    min-height: 40px;
    cursor: pointer;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 8px;
    flex-wrap: nowrap;
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;
    .unit-item{
      max-width: 90px;
      height: 22px;
      line-height: 20px;
      border-radius: 2px;
      background-color: rgba(244, 244, 245, 1);
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(233, 233, 235, 1);
      margin-left: 6px;
      display: flex;
      align-items: center;
      padding: 0 8px;
      margin-top: 8px;
      .item-text{
        width: 70px;
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;

      }
    }
  }
</style>